import { SendEmailIcon } from '@/components/icons';
import { Box, Container, Paper, Typography } from '@mui/material';
import React from 'react';
export const EmailConfirmationPage = () => {
    return (React.createElement(Container, { maxWidth: "md", sx: { minHeight: '100%' } },
        React.createElement(Box, { sx: {
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                mt: '20%',
            } },
            React.createElement(Paper, { elevation: 1, sx: {
                    flexGrow: 1,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    p: '16px',
                    borderRadius: (theme) => theme.shape.borderRadius * 2,
                } },
                React.createElement(Container, { maxWidth: "sm", sx: { flexDirection: 'column', alignItems: 'center', display: 'flex' } },
                    React.createElement(Typography, { variant: "h4", fontWeight: 600 }, "Check your email!"),
                    React.createElement(Typography, null, "We have sent your grant results to you"),
                    React.createElement(SendEmailIcon, { sx: { width: '266px', height: '267px' } }),
                    React.createElement(Paper, { elevation: 0, sx: {
                            p: '16px',
                            backgroundColor: 'primary.light',
                            width: '100%',
                            textAlign: 'center',
                        } },
                        React.createElement(Typography, { sx: { color: 'secondary.light' } }, "View the results in your email now.")))))));
};
